export default class AxiosPrefetchFailedRequestsStrategy {
  constructor(next, failProcessingStrategy) {
    this.next = next;
    this.failProcessingStrategy = failProcessingStrategy;
  }

  fail(error) {
    this.next.fail(error);
  }

  async success(config) {
    if (!config.relayOn) {
      return config;
    }

    try {
      const reqs = config.relayOn.map((dep) => this.processRequiredRequest(dep));
      await Promise.all(reqs);
    } catch {
      // do nothing
    }

    const cfg = this.failProcessingStrategy.mergeReq(config);
    return this.next.success(cfg);
  }

  processRequiredRequest(dep) {
    const eq = (cfg) => Object.entries(dep).every(([key, value]) => cfg[key] === value);
    return this.failProcessingStrategy.makeSomeRequests(eq);
  }
}
